export const supportedLanguages = ['de', 'en'];
export default {

    //gets the current language that is set in the cookie 'fbm_lang'
    //defaults to "en"
    getCurrentLang() {
        const hash = window.location.hash;
        const html = document.getElementsByTagName("html");
        if (hash && hash.includes('?lang=')) {
            const pos = hash.indexOf('?lang=');
            const lang = hash.substring(pos + 6, pos + 8).toLowerCase();
            const supportedLang = supportedLanguages.find(l => l === lang) ? lang : 'en'
            if (html && html.length > 0) {
                html[0].setAttribute("lang", supportedLang);
            }
            return supportedLang;
        }
        let lang = null;
        if (html && html.length > 0) {
            lang = html[0].getAttribute("lang");
            if (lang) lang = lang.substring(0, 2);
        }
        if (!lang && document.cookie && document.cookie !== '') {
            const lang_cookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('fbm_lang'));
            if (lang_cookie) {
                lang = lang_cookie.split('=')[1];
            }
        }
        return lang ? supportedLanguages.find(l => l === lang) ? lang : "en" : "en";
    },

    getDateFormat(){
        if(this.getCurrentLang() === 'de'){
            return 'DD.MM.YYYY'
        }
        return 'YYYY-MM-DD'
    }
}
